import { post } from "./HttpClient";

export default {
    purchaseDevice({ productId, productAttributes }) {
        const data = {
            ProductIds: [productId],
            ProductAttributes: productAttributes
        };
        return post("/", data);
    },
    purchasePlan: ({ productIds, productAttributes, targetPhoneNumber, isRenewal }) => {
        let data = {
            ProductIds: productIds,
            ProductAttributes: productAttributes,
            TargetPhoneNumber: targetPhoneNumber,
            IsRenewal: isRenewal
        }

        return post("/", data);
    }
};
